import React, { Fragment } from "react";

import withClass from "../../../../../../hoc/withClass";
import Icon from "../../../../../UI/Icon/Icon";
import Companies from "./Companies/Companies";
import AuditLogs from "./AuditLogs/AuditLogs";
import PendingTasks from "./PendingTasks/PendingTasks";

const Options = () => (
  <Fragment>
    <span
      className="nav-link"
      id="mega-menu"
      data-toggle="dropdown"
      aria-expanded="false"
      data-animation="fade"
      role="button"
      style={{ cursor: "pointer" }}
    >
      Options <Icon iconClass="icon md-chevron-down" color="white" />
    </span>
    <div className="dropdown-menu" role="menu">
      <div className="mega-content">
        <div className="row">
          <Companies />
          <AuditLogs />
          <PendingTasks />
        </div>
      </div>
    </div>
  </Fragment>
);

export default withClass(
  Options,
  "nav-item dropdown dropdown-fw dropdown-mega"
);
